import React, { useState } from "react";
import MainModal from "components/ModalMain";
import Button from "components/Button";
import ModalBillToRoomConfirm from "screens/ModalBillToRoomConfirm";
import { useMutation } from "@apollo/client";
import { CREATE_CHARGE } from "graphql/service";
import { Head, Container, Footer } from "./styles";
import colors from "constants/colors";
import ModalGeneralFailed from "screens/ModalGeneralFailed";

const ModalAddCharge = ({
  hidden,
  buttonStyle,
  bill=[],
  selectedBookingId
}) => {

  const [isOpen, setIsOpen] = useState(false);
  const [billToRoomConfirmIsOpen, setBillToRoomConfirmIsOpen] = useState(false);

  return (
    <>
      <MainModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        className="modal-success"
        buttonLabel="Bill to Room"
        buttonStyle={buttonStyle}
        hidden={hidden}
        additionalstyle={`
          max-width: 500px;
          .modal-content{
            .close {
              z-index: 200;
            }          
            .modal-body {
              height: 100%;
              padding: 24px;
            }
          }
          top: 139px;
        `}
      >
        <Head>Open Restaurant Tabs</Head>
        <Container>

        </Container>
      </MainModal>
      <ModalBillToRoomConfirm
        isOpen={billToRoomConfirmIsOpen}
        setIsOpen={setBillToRoomConfirmIsOpen}
        bill={bill}
        selectedBookingId={selectedBookingId}
      />
    </>
  );
};

export default ModalAddCharge;
